import { IOktaMFAFactorVerifyLinks } from "./IOktaMFAFactorVerifyLinks";

export interface IOktaMFAFactorPushVerifyResult {
  expiresAt: Date;
  factorResult: string;
  _links: IOktaMFAFactorVerifyLinks;
}
